import matrixLogo from '../assets/logo/matrix-logo.png';
import './Home.css';
//import publicIp from "public-ip";
import React from 'react';
import { FirestoreService } from '../services/firestoreService';
//import deviceInfoService from './services/deviceInfoService/deviceInfoService';
import HomeMediaCard from '../cards/homeMediaCard.js';
import computerVision from '../assets/cardImages/homePageImages/computer-vision.png';
import mlops from '../assets/cardImages/homePageImages/mlops.png';
import buildingBusiness from '../assets/cardImages/homePageImages/buildingBusiness.gif';
import networks from '../assets/cardImages/homePageImages/networks.png';
import articles from '../assets/cardImages/homePageImages/articles.jpg';
import plant from '../assets/cardImages/homePageImages/plant.gif';
import contactUs from '../assets/cardImages/homePageImages/contactUs.gif';
import dogewrites from '../assets/cardImages/homePageImages/dogeWrites.gif';

class Home extends React.Component {
  constructor(props) {
    super(props);
  }
  /*  componentDidMount() {
      const installGoogleAds = () => {
        const elem = document.createElement("script");
        elem.src =
          "//pagead2.googlesyndication.com/pagead/js/adsbygoogle.js";
        elem.async = true;
        elem.defer = true;
        document.body.insertBefore(elem, document.body.firstChild);
      };
      installGoogleAds();
      (window.adsbygoogle = window.adsbygoogle || []).push({});
    } */
  render() {
    return (
      <div>
        <div className="Home">
          <body className="Home-body">

            <div className="Home-card">
              <HomeMediaCard
                header=" What We Write "
                description=" We write Technical articles on IEEE, DEV Community and Medium to feed the Tech Hunger  "
                imageUrl={dogewrites}
                link='/article'
                alt="articles" />
            </div>
            
            <div className="Home-card">
              <HomeMediaCard
                header=" What We Build "
                description="We are a technology consultancy that integrates strategy, design and software engineering for modern digital businesses"
                imageUrl={buildingBusiness}
                link='https://www.buymeacoffee.com/dogealgo/extras'
                alt="IT Consulting Services" />
            </div>

            <div className="Home-card">
              <HomeMediaCard
                header=" What We Plant "
                description="When a Member Joins, We Plant a Tree 🌴, Well Technically 'We Plant a Plant' 🌱, 
                Trying to make our planet cooler by planting cute little saplings 🌱🌱🌱🌱🌱"
                imageUrl={plant}
                link='https://www.buymeacoffee.com/dogealgo/e/54988'
                alt="Plant Plants" />
            </div>

            <div className="Home-card">
              <HomeMediaCard
                header=" Get in Touch "
                description=" Are you ready to build your modern digital business with us? We are here to help you transform your business by meeting your Software requirements to digitalize your workplace "
                imageUrl={contactUs}
                link='/contact'
                alt="Get in Touch" />
            </div>
{/*
            <div className="Home-card">
              <HomeMediaCard
                header=" Computer Vision Experiments:"
                description=" You can learn about Computer Vision with Deep CNN & Transformers through Tensorflow, Pytorch & Edge devices"
                imageUrl={computerVision}
                alt="Computer Vision" />
            </div>

            <div className="Home-card">
              <HomeMediaCard
                header=" MLOps :"
                description="  You can learn about Preparing Data, Transforming Data, Processing Data, Training Model, Testing Model and Deploying ML applications through Amazon Web Services "
                imageUrl={mlops}
                alt="MLOps" />
            </div>

            <div className="Home-card">
              <HomeMediaCard
                header=" Web App Development :"
                description=" You can learn Angular, React, RestAPI design, Object Relational Mapping, Document based Datastore and Real Time Database"
                imageUrl={webapp}
                alt="webapp" />
            </div>
  */}
            {/*<div className="Home-card">
       <HomeMediaCard
       header=" Computer Networks :"
       description="Computer Networks Design and Analysis in Software Defined Networks and Information Centric Networks "
       imageUrl={networks}
       alt="networks"/>
       </div>*/}
            <div className="Home-trademarks">
              <p> &copy; Copyright 2021 &nbsp; All rights reserved</p>
              <p> Developed by Doge Algo &nbsp; </p>
            </div>
          </body>
        </div>
        { /*   <ins className='adsbygoogle'
          style={{ display: 'block' }}
          data-ad-client='ca-pub-7517034925375402'
          data-ad-slot='7517034925375402'
          data-ad-format='auto' /> */}
      </div>
    );
  }
}

export default Home;

/*
componentDidMount() {
  const deviceInfo = deviceInfoService();//service to retrive user device info
  //vistor logging procedure after the component renders to client
  const log = function(ipAddress, projectCollection){
     const data = {
       'ip4_address':ipAddress,
       'date':new Date(),
       'device_info':deviceInfo
     }
     // nosql database service
     const firestoreService = new FirestoreService(projectCollection);
     const logUser = async ()=> await firestoreService.logUser(data)
     logUser();
   } */
/* ip is passed to log() only after ip is fetched as well as
collection named log_visitor is passed */
/*
const ipLog =  async () => {
  try{
    log(await publicIp.v4(), '/log_visitor');
  }
  catch(error){
    return;
  }
}
//ipLog(); //log the ip address of host
} */
